import { FaRegStar, FaRegStarHalfStroke, FaStar } from "react-icons/fa6"

export function CourseRatingStars({ rating }: { rating: number }) {
  if (rating > 5) {
    rating = 5
  }

  const starsCount = Math.floor(rating)
  const hasHalfStars = rating - starsCount >= 0.4
  const emptyStarsCount = 5 - (starsCount + (hasHalfStars ? 1 : 0))

  const stars = [
    ...Array.from({ length: starsCount }).map((_, i) => (
      <FaStar size={26} color="#f8c315" key={`fullStar-${i}`} />
    )),
    ...(hasHalfStars
      ? [<FaRegStarHalfStroke color="#f8c315" size={27} key={"halfStar"} />]
      : []),
    ...Array.from({ length: emptyStarsCount }).map((_, i) => (
      <FaRegStar color="#f8c315" size={26} key={`emptyStar-${i}`} />
    )),
  ]

  return <div className="d-flex gap-1">{stars}</div>
}
